module.exports = __webpack_public_path__ + "img/var_02_line_right.58ada707.png";